export default "__VITE_ASSET__Ccsnmuqf__"